import clickUrl from 'url:../../asset/sound/click.mp3'
import errorUrl from 'url:../../asset/sound/error.mp3'

// Global sound enabled state
let soundEnabled = true

export const setSoundEnabled = (enabled: boolean) => {
  soundEnabled = enabled
}

export const isSoundEnabled = () => soundEnabled

let createAudioManager = (url: string) => {
  let audioArray = Array.from({ length: 10 }, () => new Audio(url))

  let k = 0
  return {
    play: () => {
      if (!soundEnabled) return
      audioArray[k].play()
      k = (k + 1) % audioArray.length
    },
  }
}

export const clickSound = createAudioManager(clickUrl)
export const errorSound = createAudioManager(errorUrl)
